import React, { useState } from 'react'
import { panelUpdateServices } from '../../../services/configurationServices';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';

const PanelLicense = ({isDeviceEdit,setIsDeviceEdit,DeviceId,alertsChecked,healthMonitoringChecked,setAlertChecked,setHealthMonitoringChecked}) => {
  // const[healthMonitoringChecked,setHealthMonitoringChecked]=useState(false);
  //  const[alertsChecked,setAlertChecked]=useState(false);

  const onPanelUpdateService = () =>{
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
    let updateObj ={
      UserID:UserID,
      DeviceId:DeviceId.toString(),
      AlertService:alertsChecked,
      HMService:healthMonitoringChecked
    }
    panelUpdateServices(updateObj).then((resp)=>{
      if(resp.Status == "success"){
        SuccessToast(resp.Message)
        //setIsDeviceEdit(false)
      }else{
        ErrorToast(resp.Message)
      }
    })
  }
  return (
    <div className="association-main-section">
      <h1 className="MainHeaderName mb-0">License Services</h1>
      <div className="SiteTextBox mt-0">
        <div
          className="onlyforEnableCheckbox ml-0"
        >
          <input
            type="checkbox"
            className="checkbox_custom"
            id="exampleCheck2"
            checked={alertsChecked}
            //disabled={!isDeviceEdit}
            onChange={() => setAlertChecked(!alertsChecked)}
          />
          <label className="" htmlFor="exampleCheck2">
            Alerts
          </label>
        </div>
      </div>
      <div className="SiteTextBox mt-0">
        <div
          className="onlyforEnableCheckbox ml-0"
        >
          <input
            type="checkbox"
            className="checkbox_custom"
            id="exampleCheck3"
            checked={healthMonitoringChecked}
            //disabled={!isDeviceEdit}
            onChange={() => setHealthMonitoringChecked(!healthMonitoringChecked)}
          />
          <label className="" htmlFor="exampleCheck3">
            Health Monitoring
          </label>
        </div>
      </div>
      <div className="m-2 text-right" style={{ textAlign: "end" }}>
          
            <button
              className="NextMoveButton m-3 manageZones-addZone-btn"
              onClick={onPanelUpdateService}
            >
              <span className="ViewUpdate">Save</span>
            </button>
          
        </div>
    </div>
  )
}

export default PanelLicense
